module.exports = __webpack_public_path__ + "img/1.f3e8c0e5.svg";